import { useCallback } from "react";
import { useApiBase } from '../base/api-baixas-base'

export const useGetLoginRepresentante = () => {
    const { invocarApi, ...props } = useApiBase();

    const getLoginRepresentante = useCallback(
        (senha: string) => {

            let queryFinal = senha.length !== 0 ? `?senha=${senha}` : '';
            return invocarApi({
                url: `v1/Operacao/Representante/login${queryFinal}`,
                method: 'GET',
                enviarTokenUsuario: false,
            })
        },
        [invocarApi],
    )
    return {
        getLoginRepresentante,
        ...props
    }
}
